import { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import staticStyles from './title.module.scss';

const components = (styles?: string, firstName?: string): JSXMapSerializer => ({
  heading1: ({ children }) => (
    <h1 className={`${staticStyles.title} ${styles ?? ''}`}>
      {children} {firstName ? `${firstName}!` : ''}
    </h1>
  ),
  heading2: ({ children }) => (
    <h2 className={`${staticStyles.title} ${styles ?? ''}`}>{children}</h2>
  ),
});

export const Title = ({
  text,
  styles,
  isVisible,
  isPreQualifiedPage = false,
  firstName,
  isEngineLanding = false,
}: {
  text: RichTextField;
  styles?: string;
  isVisible?: boolean;
  isPreQualifiedPage?: boolean;
  firstName?: string | null;
  isEngineLanding?: boolean;
}) => {
  return (
    <div
      className={`${staticStyles.title_wrapper} ${isVisible ? staticStyles.isVisible : ''}`}
    >
      {isPreQualifiedPage ? (
        <PrismicRichText
          field={text}
          components={components(styles, firstName || '')}
        />
      ) : isEngineLanding ? (
        <>
          <p className={`${staticStyles.title} ${styles ?? ''}`}>
            Hi, {firstName}!
          </p>
          <PrismicRichText field={text} components={components(styles)} />
        </>
      ) : (
        <PrismicRichText field={text} components={components(styles)} />
      )}
    </div>
  );
};
